import TopCountriesPanel from './TopCountriesPanel';

export default TopCountriesPanel;
